import { PrimaryRegularButton } from 'components/ReusableComponents/Button/RegularButtons'
import { Link } from 'react-router-dom'

import styles from './InviteMessageScopeSettings.module.scss'

const InviteEmailDesignManageLink = () => (
  <Link className={styles.manageDesignButtonLink} to="/marketing-assets/email-templates">
    <PrimaryRegularButton type="button" className={styles.manageDesignButton}>
      Manage email templates
    </PrimaryRegularButton>
  </Link>
)

export default InviteEmailDesignManageLink
